import axios from "axios";

const coreBaseUrl = process.env.REACT_APP_CORE_URL;

const externalPageApi = {
  respondPendingAssignee: async (payload = {}) => {
    const response = await axios.post(
      `${coreBaseUrl}/cta/exposed/respond/pendingAssignee`,
      payload
    );
    return response;
  },

  respondPurchaseOrder: async (payload = {}) => {
    const response = await axios.post(
      `${coreBaseUrl}/cta/exposed/respond/respondPO`,
      payload
    );
    return response;
  },

  // neww endpoint for exposed PO accept/reject for allocation
  respondExposedPOForAllocation: async (payload = {}) => {
    const response = await axios.post(
      `${coreBaseUrl}/cta/exposed/respond/exposedPO`,
      payload
    );
    return response;
  },

  respondRequestPayment: async (payload = {}) => {
    const response = await axios.post(
      `${coreBaseUrl}/cta/exposed/request/requestPayment`,
      payload
    );
    return response;
  },

  orderStatusPendingAssigneeVAlidation: async (payload = {}) => {
    const response = await axios.post(
      `${coreBaseUrl}/cta/exposed/respond/pendingAssignee/orderValidation`,
      payload
    );
    return response;
  },
  respondFinanceGroupedInvoice: async (payload = {}) => {
    const response = await axios.post(
      `${coreBaseUrl}/cta/exposed/respond/respondCreditNoteCancellation`,
      payload
    );
    return response;
  },
  listGroupedInvoiceOrOrderDetails: async (token) => {
    const response = await axios.get(
      `${coreBaseUrl}/cta/exposed/listGroupedInvoiceOrOrderDetails/${token}`
    );
    return response;
  },

  getPoDetails: async (token, email) => {
    const response = await axios.get(
      `${coreBaseUrl}/cta/exposed/poDetails/${token}${
        email ? `?email=${encodeURIComponent(email)}` : ""
      }`
    );
    return response;
  },
};

export default externalPageApi;
